import { createAsyncThunk } from "@reduxjs/toolkit";
import { apiInstance } from "../../ApiSetUp/apiInstance";
import { ApiGetNoAuth, ApiPostNoAuth } from "../../ApiSetUp/CommonApi";
import { api, BaseUrl, LOGIN_TOKEN, REFRESH_TOKEN } from "../../ApiSetUp/AuthApi";
import { setToken } from "../../ApiSetUp/ClientHelper";
import localStoreUtil from "../../ApiSetUp/localstore.util";

export function setAuthTokenAndSubscription(data) {
  apiInstance.defaults.data = data;
}

//--------------------- Auth Apis ------------------------------
export const signup = createAsyncThunk(
  "signup",
  async (body) => {
    return ApiPostNoAuth(BaseUrl, api.signup, body)
      .then((res) => {
        return res?.data;
      })
      .catch((err) => err);
  }
);

export const login = createAsyncThunk(
  "login",
  async (body, thunkAPI) => {
    return await ApiPostNoAuth(BaseUrl, api.login, body)
      .then(async (res) => {
        const currentTime = new Date().getTime();
        if (res?.data?.data) {
          await setToken(res?.data?.data?.token);
          await localStoreUtil.store_data(LOGIN_TOKEN, res?.data?.data?.token);
          await localStoreUtil.store_data("User_Data", res?.data?.data?.user);
          await localStoreUtil.store_data("Time", currentTime.toString());
        }
        return res?.data;
      })
      .catch((err) => err);
  }
);

export const forgotPassword = createAsyncThunk(
  "forgotPassword",
  async (body) => {
    return ApiPostNoAuth(BaseUrl, api.forgotPassword, body)
      .then((res) => {
        return res?.data;
      })
      .catch((err) => err);
  }
);
export const otpVerification = createAsyncThunk(
  "otpVerification",
  async (body) => {
    return ApiPostNoAuth(BaseUrl, api.otpVerification, body)
      .then((res) => {
        return res?.data;
      })
      .catch((err) => err);
  }
);
export const updatePassword = createAsyncThunk(
  "updatePassword",
  async (body) => {
    return ApiPostNoAuth(BaseUrl, api.updatePassword, body)
      .then((res) => {
        return res?.data;
      })
      .catch((err) => err);
  }
);
export const get_all_notifications = createAsyncThunk(
  "get_all_notifications",
  async (body) => {
    return ApiPostNoAuth(BaseUrl, api.get_all_notifications, body)
      .then((res) => {
        return res?.data;
      })
      .catch((err) => err);
  }
);

export const getGeneralConfigurationForConsultant = createAsyncThunk(
  "getGeneralConfigurationForConsultant",
  async (body) => {
    return ApiGetNoAuth(BaseUrl, api.GetGeneralConfigurationForConsultant, {})
      .then((res) => {
        return res?.data;
      })
      .catch((err) => err);
  }
);
export const getLoggedInUserDetails = createAsyncThunk(
  "getLoggedInUserDetailsINFO",
  async (body) => {
    return await ApiGetNoAuth(`/ed/api/`, api.GetGeneralConfigurationForConsultant, {})
      .then(async (res) => {
        return res?.data?.data;
      })
      .catch((err) => err);
  }
);
